import React, { useState, useEffect } from "react";
import {
    Container,
    Col,
    Form,
    Row,
    Spinner,
    Table,
    Button,
    Modal,
    Alert,
} from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import messages from "../../redux/messages";
import * as Yup from "yup";
import {
    getPlanCarreraIndividual,
    savePlanCarreraIndividual,
    editPlanCarreraIndividual,
    saveCoursePlanCarreraIndividual,
    deleteCoursePlanCarreraIndividual,
    getInfoEncabezado,
    clearPlanCarreraIndividual
} from "../../redux/Carrera_Sucesion/PlanCarreraIndividual/actions";
import { Formik } from "formik";

import {
    getCourseFun,

} from "../../redux/Carrera_Sucesion/CursosFunciones/actions";
import { Typeahead } from "react-bootstrap-typeahead";


const PlanCarreraIndividual = (props) => {
    const [show, setShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [validated, setValidated] = useState(false);

    const dispatch = useDispatch();

    const schema = Yup.object().shape({
        cursos_funcion: Yup.string().required("**Campo requerido"),

    });


    const {
        loading,
        saveLoading,
        planCarrera,
        planCarreraError,
        formError,
        infoEncabezado,
        loadingInfoEncabezado
    } = useSelector((store) => store.planCarreraIndividual)

    const {
        coursesFuncion
    } = useSelector((store) => store.cursosFuncion);




    useEffect(() => {
        dispatch(getInfoEncabezado({
            titular: props.match.params.codigoTitular,
            matriz: props.match.params.idMatriz
        }));
    }, [])

    useEffect(() => {
        if (infoEncabezado) {
            dispatch(getCourseFun({
                tipo_busqueda: 'funcion_codigo',
                filter: infoEncabezado.posicion_aspirar_codigo
            }))
        }

    }, [infoEncabezado])

    let cursosFuncionOptions = [];

    if (coursesFuncion) {
        cursosFuncionOptions = coursesFuncion.map((course) => ({
            id: course.id,
            label: course.list_curso
                ? `${course.list_curso[0].codigo} / ${course.list_curso[0].nombre.toUpperCase()}`
                : "",
            item: course,
        }));
    }

    const _getPlanCarreraIndividual = () => {
        dispatch(getPlanCarreraIndividual({
            codigo_titular: props.match.params.codigoTitular,
            matriz_id: props.match.params.idMatriz
        }));

    }

    const _createPlanCarreraIndividual = () => {
        dispatch(savePlanCarreraIndividual({
            codigo_titular: props.match.params.codigoTitular,
            matriz_id: props.match.params.idMatriz
        }))
    }

    useEffect(() => {
        dispatch(clearPlanCarreraIndividual())
        _getPlanCarreraIndividual()
    }, [])

    useEffect(() => {
        if (planCarreraError) {
            _createPlanCarreraIndividual()
        }
    }, [planCarreraError])


    const handleEditSubmit = (item, index) => {
        let nuevaMarca = !item.marca
        let _req = {
            marca: nuevaMarca === true ? "1" : "0",
            codigo_titular: props.match.params.codigoTitular,
            matriz_id: props.match.params.idMatriz
        }
        dispatch(editPlanCarreraIndividual(_req, item.id, index))
    }

    const addCurso = () => {
        setShowModal(true);
        setValidated(false)
    }

    const onDelete = (id, index) => {
        if (window.confirm(messages.preguntaEliminar)) {
            dispatch(deleteCoursePlanCarreraIndividual(id, index));

        }
    }

    const onSubmit = async (req) => {
        let _req = {
            cursos_funcion: req.cursos_funcion,
            titular: props.match.params.idTitular,
            matriz: props.match.params.idMatriz,
            tipo: 1
        }
        let filters = {
            codigo_titular: props.match.params.codigoTitular,
            matriz_id: props.match.params.idMatriz
        }
        dispatch(saveCoursePlanCarreraIndividual(_req, setShowModal, filters))
        console.log(_req)
    }


    const onShowSidebar = () => setShow(show ? false : true);

    const cursosTipo1 = planCarrera && planCarrera.cursos_titulares_creados ? planCarrera.cursos_titulares_creados?.filter(curso => curso.tipo === 1).sort((a, b) => a.orden - b.orden) : [];
    const countCursosChecked = planCarrera ? cursosTipo1.filter(curso => curso.marca === true).length : 0;
    const competenciasTipo1 = planCarrera && planCarrera.competencias_titulares_creados ? planCarrera.competencias_titulares_creados?.filter(competencia => competencia.tipo === 1) : [];
    const competenciasTipo2 = planCarrera && planCarrera.competencias_titulares_creados ? planCarrera.competencias_titulares_creados?.filter(competencia => competencia.tipo === 2) : [];
    const maxLengthCompetencias = Math.max(competenciasTipo1.length, competenciasTipo2.length);
    let counter = 0
    const coursesCounter = cursosTipo1 ? cursosTipo1.length : 0;
    const porcentajeCompletado = ((countCursosChecked / cursosTipo1.length) * 100).toFixed(2)

    return (
        <>
            {(loading || saveLoading || loadingInfoEncabezado) ? (
                <div className='d-flex justify-content-center'>
                    <Spinner
                        animation='border'
                        role='status'
                        className='d-flex justify-content-center'
                    />
                </div>
            ) : (
                <div>
                    <Container>

                        <Row className="d-flex flex-wrap align-items-center mt-5">
                            <Col md={6} lg={2} className="border-1 mb-3 mr-2 p-2 text-white rounded" style={{ backgroundColor: "#6c757d" }}>
                                <p>Empleado:</p>
                            </Col>
                            <Col md={6} lg={3} className="border-1 mb-3 p-2" >
                                <p style={{ fontWeight: "bold" }}>{infoEncabezado?.nombre_titular || ""}</p>
                            </Col>
                            <Col md={6} lg={2} className="border-1 mb-3 mr-2 p-2 text-white rounded" style={{ backgroundColor: "#6c757d" }}>
                                <p>Posición actual:</p>
                            </Col>
                            <Col md={6} lg={3} className="border-1 mb-3 p-2 ">
                                <p style={{ fontWeight: "bold" }}>{infoEncabezado?.posicion_actual || ""}</p>
                            </Col>


                        </Row>
                        <Row>
                            <Col md={6} lg={2} className="border-1 mb-3 mr-2 p-2 text-white rounded" style={{ backgroundColor: "#6c757d" }}>
                                <p>Función a aspirar:</p>
                            </Col>
                            <Col md={6} lg={3} className="border-1 mb-3 p-2 ">
                                <p style={{ fontWeight: "bold" }}>{`${infoEncabezado?.posicion_aspirar_codigo} / ${infoEncabezado?.posicion_aspirar} ` || ""}</p>
                            </Col>
                        </Row>

                    </Container>


                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                {console.log("cursos", coursesCounter)}
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th className="text-center">Plan de Carrera</th>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }} className="text-center">{!isNaN(porcentajeCompletado)? porcentajeCompletado : 0}%</th>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th>No</th>
                                <th className="text-center" style={{ width: "270px" }} colSpan={3}>{infoEncabezado?.posicion_aspirar || ""}</th>

                                <th style={{ backgroundColor: "#fff", border: "0px" }}>
                                    <Button
                                        variant="primary"
                                        onClick={addCurso}
                                    >
                                        Agregar Curso
                                    </Button></th>
                                <th className="text-center" style={{ width: "200px" }} >{infoEncabezado?.posicion_aspirar || ""}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <td rowSpan={coursesCounter + 1} style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)', textAlign: 'center', fontWeight: "bold" }}>
                                Ruta de Aprendizaje
                            </td>

                            {(planCarrera?.cursos_titulares_creados && coursesCounter > 0) ?
                                planCarrera.cursos_titulares_creados.map((curso, index) => {
                                    if (curso.tipo == 1) {
                                        counter++
                                        return (
                                            <tr key={index}>
                                                <td>{counter}</td>
                                                <td>{curso.cursos_funcion__curso__nombre}</td>
                                                <td>
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={curso.marca}
                                                        onChange={() => handleEditSubmit(curso, index)}
                                                    />

                                                </td>
                                                <td>
                                                    <Button
                                                        size="sm"
                                                        className="text-danger"
                                                        variant="link"
                                                        type="button"
                                                        onClick={() => onDelete(curso.id, index)}
                                                    >
                                                        <i className="material-icons">delete</i>
                                                    </Button>
                                                </td>

                                                {counter === 1 && (
                                                    <td rowSpan={cursosTipo1.length} style={{ backgroundColor: "#fff", border: "0px" }}></td>
                                                )}

                                                <td className="text-center">
                                                    {curso.marca === true ? (
                                                        <i className="material-icons text-success">check</i>
                                                    ) : (<i className="material-icons text-danger">close</i>)}

                                                </td>
                                            </tr>
                                        )
                                    }
                                })
                                :
                                (


                                    <td style={{ backgroundColor: "#fff", border: "0px" }}>
                                        <Alert variant="info">
                                            No hay cursos registrados, comience agregando algunos.
                                        </Alert>
                                    </td>

                                )

                            }

                        </tbody>
                    </Table>

                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th>No</th>
                                <th className="text-center" style={{ width: "270px" }} colSpan={2}>{infoEncabezado?.posicion_actual || ""}</th>
                                <th>No</th>
                                <th className="text-center" style={{ width: "270px" }} colSpan={2}>{infoEncabezado?.posicion_aspirar || ""}</th>
                                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                                <th className="text-center" style={{ width: "200px" }}>{infoEncabezado?.posicion_aspirar || ""}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <td rowSpan={maxLengthCompetencias + 1} style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)', textAlign: 'center', fontWeight: "bold" }}>
                                Competencias Organizacionales
                            </td>

                            {Array.from({ length: maxLengthCompetencias }, (_, index) => (
                                <tr key={index}>
                                    <td>{competenciasTipo1[index].orden}</td>
                                    <td>{competenciasTipo1[index] ? `${competenciasTipo1[index].nombre}` : ""}</td>
                                    <td>
                                        {competenciasTipo1[index].nivel_desarrollo}
                                    </td>
                                    <td>{competenciasTipo2[index].orden}</td>
                                    <td>{competenciasTipo2[index] ? `${competenciasTipo2[index].nombre}` : ""}</td>
                                    <td>
                                        {competenciasTipo2[index].nivel_desarrollo}
                                    </td>
                                    {index === 0 && (
                                        <td rowSpan={maxLengthCompetencias} style={{ backgroundColor: "#fff", border: "0px" }}></td>
                                    )}
                                    <td className="text-center" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                        {competenciasTipo1[index].nivel_desarrollo - competenciasTipo2[index].nivel_desarrollo > 0 ? (
                                            <i className="material-icons text-success">check</i>
                                        ) : (<i className="material-icons text-danger">flag</i>)}
                                        {competenciasTipo1[index].nivel_desarrollo - competenciasTipo2[index].nivel_desarrollo}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <Modal
                        show={showModal}
                        onHide={() => {
                            setShowModal(false);
                        }}
                    >
                        <Formik
                            validationSchema={schema}
                            onSubmit={onSubmit}
                            initialValues={{
                                cursos_funcion: ""
                            }}

                        >

                            {({
                                handleSubmit,
                                handleChange,
                                handleBlur,
                                setFieldValue,
                                values,
                                touched,
                                errors,
                            }) => (


                                <Form onSubmit={handleSubmit} noValidate validated={validated}>
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-muted">
                                            Agregar curso función
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {formError && (
                                            <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                                                {formError}
                                            </Alert>
                                        )}

                                        <Form.Group className="mb-3">
                                            <Form.Label column sm="12" md="12">
                                                Curso función:
                                            </Form.Label>
                                            <Row className="d-flex flex-wrap align-items-center">
                                                <Col sm={11} xs={11}>
                                                    <Typeahead
                                                        id="curso_funcion"
                                                        name="cursos_funcion"
                                                        isInvalid={touched.cursos_funcion && errors.cursos_funcion}
                                                        isValid={touched.cursos_funcion && !errors.cursos_funcion}
                                                        onBlur={handleBlur("Curso")}
                                                        placeholder="Seleccione un curso"
                                                        options={cursosFuncionOptions}
                                                        value={values.cursos_funcion}
                                                        onChange={(selected) => {
                                                            setFieldValue(
                                                                "cursos_funcion",
                                                                selected.length > 0 ? selected[0].id : "",

                                                            );

                                                        }}

                                                    >

                                                    </Typeahead>
                                                </Col>
                                            </Row>


                                        </Form.Group>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            className="rounded-pill"
                                            variant="secondary"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Cerrar
                                        </Button>
                                        <Button
                                            className="rounded-pill"
                                            variant="primary"
                                            disabled={saveLoading}
                                            type="submit"


                                        >
                                            {" "}
                                            {saveLoading && (
                                                <Spinner
                                                    className="mr-2"
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />

                                            )}
                                            Guardar

                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            )}
                        </Formik>

                    </Modal>
                </div >

            )}



        </>


    );
};

export default PlanCarreraIndividual;
